import router from "./router/router";
import store from "./core/services/store";
import { Message } from 'element-ui'

// import auth from "./auth.module";
// import { getToken } from '@/utils/auth' // get token from cookie
// import getPageTitle from '@/utils/get-page-title'

// NProgress.configure({ showSpinner: false }) // NProgress Configuration
const whiteList = ['/login', '/poster', '/pickupCode', '/thirdPay','UploadPublishFile'] // no redirect whitelist
var getRouter // 用来获取后台拿到的路由

router.beforeEach(async (to, from, next) => {
  // console.log()
  // start progress bar
  // NProgress.start()
  // set page title
  // document.title = getPageTitle(to.meta.title)
  // determine whether the user has logged in
  var hasToken = store.getters.isAuthenticated
  var pattern = 'one'
  if (to.query.token) {
    pattern = 'two'
    await store.dispatch('user/swsetToken', to.query.token).then(res => {
      hasToken = to.query.token
      next()
      return false
    })
  }
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      // NProgress.done()
    } else {
     
        try {
          next()
          // get user info
          // if (pattern == 'tow') {
          //   next()
          // }
          // if (pattern != 'tow') {
          //   console.log(88888888666)
          //   await store.dispatch('user/getInfo')
          //   if (store.getters.shop) {
          //     next()
          //   }
          // }

          // const menus = filterAsyncRouter(store.getters.menus)
          // const menus = filt erAsyncRouter(store.getters.menus) // 1.过滤路由
          // console.log(menus)
          // menus.push({ path: '*', redirect: '/404', hidden: true })
          // router.addRoutes(menus) // 2.动态添加路由
          // global.antRouter = menus // 3.将路由数据传递给全局变量，做侧边栏菜单渲染工作
          // next({
          //   ...to,
          //   replace: true
          // }) // hack方法 确保addRoutes已完成 ,set the replace
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          // NProgress.done()
        }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      // NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  // NProgress.done()
})

